/** @jsxRuntime classic */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOMClient from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// Load Honeycomb CSS
/* eslint-disable import/no-extraneous-dependencies */
import '@honeycomb-npm/honeycomb/src/bundles/honeycomb.scss';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Router basename="/business-banking/paymenttracker">
            <App />
        </Router>

    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
